
import { RichContent } from '@/modules/RichContent'
import { mapActions, mapGetters } from 'vuex'
import PaymentsModal from '@/components/common/PaymentsModal'
import PaymentResubmitDialog from '@/components/common/PaymentResubmitDialog'
import { veeValidator } from '../../mixins/veeValidator'

export default {
  name: 'OrderCTA',
  components: {
    PaymentsModal,
    PaymentResubmitDialog
  },
  mixins: [veeValidator],
  props: {
    blok: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      showResubmitModal: false,
      buttonDisabled: false,
      isHidden: true,
      quantity: 1,
      form: {
        phone: ' '
      },
      modal: { show: false },
      name: ''
    }
  },
  computed: {
    messages() {
      let priceMessage = ''
      let paymentMessage = ''

      const pricing = this.pricing(this.blok.pid.selected, this.quantity)
      const message =
        '<del class="price-strike">$' +
        this.prettyNumber(pricing.originalPrice) +
        '</del> Only $' +
        this.prettyNumber(pricing.subTotal)
      const messageRemoveOnly =
        '<del class="price-strike">$' +
        this.prettyNumber(pricing.originalPrice) +
        '</del> $' +
        this.prettyNumber(pricing.subTotal)
      const messagePriceOnly = 'Only $' + this.prettyNumber(pricing.subTotal)
      const messagePrice = '$' + this.prettyNumber(pricing.subTotal)
      const messageFree = 'FREE!'
      if (pricing.originalPrice > pricing.subTotal) {
        priceMessage = message
      }
      if (this.blok.removeOnlyText === true) {
        priceMessage = messageRemoveOnly
      }
      if (pricing.originalPrice <= pricing.subTotal) {
        priceMessage = messagePriceOnly
      }
      if (
        pricing.originalPrice <= pricing.subTotal &&
        this.blok.removeOnlyText
      ) {
        priceMessage = messagePrice
      }
      if (pricing.price <= 0) {
        priceMessage = messageFree
      }

      const paymentPlan = this.offers.find(
        o => o.payments.paymentPlanFor === parseInt(this.blok.pid.selected)
      )
      if (paymentPlan) {
        paymentMessage =
          '<br />Or ' +
          paymentPlan.payments.numberOfPayments +
          ' monthly payments of $' +
          this.prettyNumber(paymentPlan.pricing.displayPrice) +
          ' each'
      }

      return {
        priceMessage: priceMessage,
        paymentMessage: paymentMessage,
        taxOverride: '(plus state sales tax where applicable)'
      }
    },
    ctaText() {
      if (this.purchased) return 'Purchased'
      return !this.buttonDisabled ? this.blok.button_text : 'Expired'
    },
    purchased: function() {
      return this.confirmedPurchase(this.blok.pid.selected)
    },
    richContent: function() {
      return RichContent(this.blok.confirmation_message.content, {
        customer: this.$store.getters.customer(),
        pricing: this.$store.getters.pricing(this.blok.pid.selected)
      })
    },
    ctaId: function() {
      return this.blok.button_action === 'submit' ? 'lastCTA' : ''
    },
    maxQuantity: function() {
      return Array(parseInt(this.blok.quantity_max))
        .fill(1)
        .map((x, y) => x + y)
    },
    buttonType() {
      return this.blok.button_type || 'button-submit button red-arrow'
    },
    showArrows() {
      return this.blok.show_arrows !== false ? true : this.blok.show_arrows
    },
    shortUID() {
      return this.blok._uid
        .split('-')
        .pop()
        .split('-')
        .pop()
    },
    ...mapGetters([
      'offers',
      'offer',
      'pricing',
      'customer',
      'confirmedPurchase',
      'busy',
      'paymentError'
    ])
  },
  mounted() {
    this.offers.forEach(offer => {
      if (offer.product.id === this.blok.pid.selected) {
        this.name = offer.product.displayName
      }
    })
    this.$validator.localize('en', this.dictionary)
    this.form.phone = this.customer().phone
    this.$bus.$on('timerExpired', () => {
      this.buttonHandler()
    })
    this.$bus.$on('closeResubmitDialog', res => {
      this.showResubmitModal = false
      if (res.hideError === true) {
        this.isHidden = true
      }
    })
  },
  beforeDestroy() {
    this.$bus.$off('timerExpired')
    this.$bus.$off('closeResubmitDialog')
  },
  methods: {
    buttonHandler() {
      return (this.buttonDisabled = true)
    },
    selectQuantity(quantity) {
      this.quantity = quantity
    },
    callToAction() {
      if (this.purchased) {
        return false
      }

      if (this.blok.button_action === 'submit') {
        this.$validator.validateAll().then(success => {
          if (success) {
            this.submitOrder()
          } else {
            this.$vuetify.goTo('.error--text', { offset: 50 })
          }
        })
      }

      if (this.blok.button_action === 'checkout') {
        if (document.getElementById('checkoutForm')) {
          this.$vuetify.goTo('#checkoutForm')
        } else {
          this.nextStep({
            acceptOffer: true,
            productId: this.blok.pid.selected
          })
        }
      }

      if (this.blok.button_action === 'lastCTA') {
        this.$bus.$emit('confirm')
        this.$vuetify.goTo('#lastCTA', { offset: 150 })
      }
      if (this.blok.button_action === 'paymentModal') {
        this.$validator.validateAll().then(success => {
          if (success) {
            this.openMyDialog()
          } else {
            this.$vuetify.goTo('.error--text', { offset: 50 })
          }
        })
      }
    },
    openMyDialog() {
      if (
        // triggers modal on 4+ payments, needs to be explicit for legal reasons
        this.offer(this.blok.pid.selected).payments.numberOfPayments >= 4 ||
        // triggers modal on > 4 payments and if there are items in the form array
        (this.offer(this.blok.pid.selected).payments.numberOfPayments < 4 &&
          Array.isArray(
            this.offer(this.blok.pid.selected).payments.paymentModalCheckboxes
          ) &&
          this.offer(this.blok.pid.selected).payments.paymentModalCheckboxes
            .length >= 1)
      ) {
        this.modal.show = true
      } else {
        this.submitOrder()
      }
    },
    submitOrder(TILAAgreement) {
      const purchaseDetails = {
        productId: this.blok.pid.selected,
        quantity: this.quantity
      }
      if (typeof TILAAgreement !== 'undefined') {
        Object.assign(purchaseDetails, TILAAgreement)
      }
      if (this.form.phone.trim() !== this.customer().phone.trim()) {
        purchaseDetails.updatePhone = this.form.phone
      }
      this.purchase(purchaseDetails).then(({ errorCode }) => {
        if (errorCode) {
          this.$vuetify.goTo('#ctaPaymentAlert-' + this.blok._uid)

          this.isHidden = false
        }
      })
    },
    prettyNumber: function(x) {
      return x.toLocaleString('en', {
        useGrouping: true,
        minimumFractionDigits: 2
      })
    },
    ...mapActions({
      nextStep: 'nextStep',
      purchase: 'purchase'
    })
  }
}
